@if (fileContentModel || isCustomerSurvey || isPartnerSurvey) {
  <div
    class="modal fade ack-Zindex"
    tabindex="-1"
    id="previewModal"
    role="dialog"
    data-backdrop="static">
    <div class="modal-dialog modal-xl">
      @if (!isCustomerSurvey && !isPartnerSurvey) {
        <div class="modal-content new-nomination-pop-up">
          @if (!fileContentModel.fileFound) {
            <div class="col-11">
              <p class="ms-fontSize-m ms-fontWeight-bold customer-error mb-1">
                The File is not found in Blob !
              </p>
            </div>
          }
          <div class="modal-body ack-modal-body p-0">
            @if (checkIsImage(fileContentModel.previewFileType)) {
              <img
                class="uploaded-img mr-2 ack-prev-image"
                [src]="fileContentModel.fileUrl"
                alt="Preview Image" />
            }
            @if (checkIsPdf(fileContentModel.previewFileType)) {
              <pdf-viewer
                class="ack-prev-pdf d-flex"
                id="pdfViewer"
                [src]="fileContentModel.fileUrl"
                [show-borders]="true"
                [render-text]="true"
                (after-load-complete)="
                  afterPdfLoadComplete($event)
                "></pdf-viewer>
            }
            @if (checkIsDoc(fileContentModel.previewFileType)) {
              <ngx-doc-viewer
                [url]="fileContentModel.fileUrl"
                [viewer]="viewerName"
                style="width: 100%; height: 70vh"></ngx-doc-viewer>
            }
            @if (checkIsUnSupportedFileType(fileContentModel.previewFileType)) {
              <label for="unsupportedFileType">Unsupported file Type</label>
            }
            <input type="hidden" id="unsupportedFileType" />
          </div>

          <div
            class="modal-footernew-nomination-modal-footer-padding mr-3 ml-3 pr-0"></div>
        </div>
      }

      @if (
        (isCustomerSurvey || isPartnerSurvey) &&
        engagementPreviewInput.customerSurveyResponse.length > 0
      ) {
        <div class="modal-content response-table new-nomination-pop-up p-3">
          <table class="reptable" cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>Ques#</th>
                <th>Questions</th>
                <th>Response</th>
              </tr>
            </thead>
            @for (
              customerSurveyResponse of engagementPreviewInput.customerSurveyResponse;
              track customerSurveyResponse
            ) {
              <tr>
                <td>{{ customerSurveyResponse.questionNo }}</td>
                <td>{{ customerSurveyResponse.questions }}</td>
                <td>{{ customerSurveyResponse.responses }}</td>
              </tr>
            }
          </table>
        </div>
      }
    </div>
  </div>
}
